module.exports = import("https://cdn.jsdelivr.net/npm/@resolverworks/enson@0.0.12/dist/index.min.js");;